module.exports = __webpack_public_path__ + "2ad56282a56663f9a3efed183c052e7d.jpg";